import { store, getContext, getElement } from '@wordpress/interactivity';



const { actions, state } = store( 'iowa-aea-theme/header-slider', {
  state: {
    currentSlide: 0,
    paused: false,
    interval: null,
  },
  actions: {
    nextSlide: (context) => {
      let next = state.currentSlide + 1;

      let slidesData = context.slides || [];

      if (next >= slidesData.length) {
        next = 0;
      }

      actions.setVisibleSlide(next);
    },
    loadSlideShow: () => {
      const context = getContext();
      const element = getElement();

      let slidesData = context.slides || [];

      let slide = document.createElement('div');
      slide.classList.add('slide');

      element.ref.appendChild(slide);

      let contentTabContainer = document.createElement('div');
      contentTabContainer.classList.add('content-tab-container');

      slide.appendChild(contentTabContainer);

      let slideContents = document.createElement('div');
      slideContents.classList.add('slide-contents');
      contentTabContainer.appendChild(slideContents);

      let tabContents = document.createElement('div');
      tabContents.classList.add('tab-contents');
      contentTabContainer.appendChild(tabContents);

      let imageContents = document.createElement('div');
      imageContents.classList.add('image-contents');

      slide.appendChild(imageContents);

      slidesData.forEach((slide, index) => {

        // slide contents
        let slideContent = document.createElement('div');
        slideContent.classList.add('slide-content');
        slideContent.setAttribute('tabindex', 0);
        slideContent.innerHTML = `
          <div class='slide-title'>${slide.title}</div>
          <p>${slide.content}</p>
          <div class='wp-block-button'>
            <a class='wp-block-button__link has-text-align-center' style='display: inline-block;' href="${slide.buttonUrl ? slide.buttonUrl : '#'}" class="button">${slide.buttonText ? slide.buttonText : 'Learn More'}</a>
          </div>
        `;
        slideContent.dataset.slideIndex = index;
        slideContents.appendChild(slideContent);

        // tab contents
        let tabContent = document.createElement('div');
        tabContent.classList.add('label-content');
        tabContent.innerHTML = slide.slideLabel;
        tabContent.dataset.slideTabIndex = index;
        tabContent.addEventListener('click', () => {
          actions.setVisibleSlide(index);
        })
        tabContents.appendChild(tabContent);

        // image contents
        let imageContent = document.createElement('div');
        imageContent.classList.add('image-content');
        imageContent.dataset.slideIndex = index;
        imageContent.innerHTML = `<img src="${slide.image}" alt="${slide.title}" loading="lazy" />`;
        imageContents.appendChild(imageContent);
      });

      actions.startSlideshow();
    },
    setVisibleSlide(index){
      state.currentSlide = index;
      let currentHiddenSlides = document.querySelectorAll('[data-slide-index].hide');

      currentHiddenSlides.forEach((currentHiddenSlide) => {
        currentHiddenSlide.classList.remove('hide');
      });

      let currentSlides = document.querySelectorAll('[data-slide-index].show');

      currentSlides.forEach((currentSlide) => {
        currentSlide.classList.remove('show');
        currentSlide.classList.add('hide');
      });

      const slides = document.querySelectorAll('[data-slide-index]');
      slides.forEach((slide) => {
        if (slide.dataset.slideIndex == index) {
          slide.classList.add('show');
        }
      });

      const slideTabs = document.querySelectorAll('[data-slide-tab-index]');
      slideTabs.forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.slideTabIndex == index);
      });
    },
    startSlideshow: () => {
      let context = getContext();
      actions.setVisibleSlide(state.currentSlide);

      let interval = setInterval(() => {
        actions.nextSlide(context)
      }, 15000)

      state.interval = interval
    },
    pauseSlideShow: () => {
      clearInterval(state.interval)
    }
  },
  init: {
    setup: () => {
      actions.loadSlideShow();
    }
  }
});
